import axios from 'axios'
import store from '@/store'
import $toast from '@/utils/toast'

// 创建axios实例
const instance = axios.create({
	timeout: 60 * 1000    // 请求超时
})
// 拦截器
instance.interceptors.response.use(
	response => {
		const res = response.data
		// 请求成功
		if (res.result == 1 || res.result == 200 || res.code == 1 || res.code == 200) {
			return res
		} else {
			$toast({message: res.msg || res.message || '请求出错，请稍后重试'}).show()
      if (res.result == 11037) {
        setTimeout(() => {
          store.dispatch('user/logout')
          location.reload()
        }, 1000)
      }
			return Promise.reject(res.msg || res.message || '请求出错，请稍后重试')
    }
	},
	error => {
		return Promise.reject(error)
	}
)

export default instance
